import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    resultList: [],
    totalRecords: 0,
    resultDetails: {},
    message: null,
    createEditResultListLoading: false,
    createEditResultListSuccess: {},
    createEditResultListError: '',
    resultBannerList: [],
    totalBannerRecords: 0,
    Bannermessage: '',
}

export const resultListSlice = createSlice({
    name: 'resultList',
    initialState,
    reducers: {
        getResultList: (state, action) => {
            state.resultList = action.payload.data?.data;
            state.totalRecords = action.payload.data?.totalRecord;
            state.message = action.payload.message;
        },
        getResultBannerList: (state, action) => {
            state.resultBannerList = action.payload.data?.data;
            state.totalBannerRecords = action.payload.data?.totalRecord;
            state.Bannermessage = action.payload.message;
        },
        getResultDetails: (state, action) => {
            state.resultDetails = action.payload
        },
        setCreateEditResultLoading: (state) => {
            state.createEditResultListLoading = true;
            state.createEditResultListSuccess = {};
            state.createEditResultListError = '';
        },
        setCreateEditResultSuccess: (state, action) => {
            state.createEditResultListLoading = false;
            state.createEditResultListSuccess = action.payload;
            state.createEditResultListError = '';
        },
        setCreateEditResultError: (state, action) => {
            state.createEditResultListLoading = false;
            state.createEditResultListSuccess = {};
            state.createEditResultListError = action.payload;
        },
        resetResultData: (state, action) => {
            state.createEditResultListLoading = false;
            state.createEditResultListSuccess = {};
            state.createEditResultListError = '';
        },
    },
})

// Action creators are generated for each case reducer function
export const { getResultList, getResultBannerList, getResultDetails, setCreateEditResultLoading, setCreateEditResultSuccess, setCreateEditResultError, resetResultData } = resultListSlice.actions

export default resultListSlice.reducer;